import { render, staticRenderFns } from "./PixabayImageBrowser.vue?vue&type=template&id=800c544c&scoped=true"
import script from "./PixabayImageBrowser.vue?vue&type=script&lang=js"
export * from "./PixabayImageBrowser.vue?vue&type=script&lang=js"
import style0 from "./PixabayImageBrowser.vue?vue&type=style&index=0&id=800c544c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "800c544c",
  null
  
)

export default component.exports